import { combineReducers } from 'redux';

import jobs from './jobs';

export default combineReducers({
  jobs,
});
